const periodontology = {
  hero: {
    topLine: "Специалисти по Здравето на Венците",
    titleLine1: "Съвременна Пародонтология",
    titleLine2: "за Здрави Венци",
    description:
      "Нашите специализирани пародонтологични лечения третират заболяванията на венците и подобряват оралното здраве чрез съвременни, минимално инвазивни техники.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете Повече",
    },
    imageAlt: "Съвременно Пародонтологично Лечение",
    stats: {
      value: "98%",
      label: "Успеваемост",
    },
    floatingLabel: "Възстановяване на Венците",
  },
  benefits: {
    heading: "ЗАЩО ДА ИЗБЕРЕТЕ НАС",
    intro:
      "Получете цялостно парадонтално лечение,фокусирано върху превенцията и дългосрочното здраве на венците ви.",
    items: [
      {
        title: "Превенция на Пародонтални Заболявания",
        description:
          "Нашите лечения помагат за предотвратяване и контрол на пародонтита, запазвайки зъбите и усмивката ви.",
      },
      {
        title: "Подобрено Общо Здраве",
        description:
          "Здравите венци допринасят за по-добро общо здраве чрез намаляване на риска от възпаление и бактериални инфекции.",
      },
      {
        title: "Ранно Откриване",
        description:
          "Идентифицираме и третираме пародонталните проблеми рано, предотвратявайки прогресирането към по-тежки състояния.",
      },
    ],
  },
  process: {
    heading: "НАШИЯТ ПРОЦЕС НА ПАРОДОНТАЛНО ЛЕЧЕНИЕ",
    intro:
      "Систематичен подход към диагностиката и лечението на пародонтални заболявания за оптимално здраве на венците",
    stepLabel: "Стъпка",
    items: [
      {
        title: "Цялостна Оценка",
        description:
          "Обстоен преглед на венците, измерване на дълбочината на джобовете и проверка за възпаление и кървене.",
      },
      {
        title: "Диагностика и Планиране",
        description:
          "Детайлна диагностика на пародонталното състояние и създаване на персонализиран план за лечение.",
      },
      {
        title: "Специализирано Лечение",
        description:
          "Съвременни пародонтални терапии, включващи почистване, заглаждане на корените и лазерно лечение при необходимост.",
      },
      {
        title: "Поддръжка и Проследяване",
        description:
          "Редовни прегледи и поддържащо лечение за осигуряване на дългосрочното здраве на венците и предотвратяване на рецидиви.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro:
      "Получете отговори на често задавани въпроси за пародонталното здраве и лечение",
    items: [
      {
        question: "Какво е пародонтално заболяване?",
        answer:
          "Пародонталното заболяване, известно още като заболяване на венците, е инфекция на тъканите, които държат зъбите на място. Обикновено се причинява от лоша хигиена на зъбите и венците, която позволява натрупването на плака – лепкав филм от бактерии, който се втвърдява върху зъбите.",
      },
      {
        question: "Какви са признаците на заболяване на венците?",
        answer:
          "Често срещаните признаци включват зачервени, подути или чувствителни венци, кървене при миене на зъби или използване на конец, отдръпване на венците, постоянен лош дъх, разклащане на зъби и промени в захапката.",
      },
      {
        question: "Болезнено ли е пародонталното лечение?",
        answer:
          "Повечето пародонтални лечения се извършват с локална анестезия, осигурявайки вашия комфорт. За по-обширни процедури са налични опции за седация. Дискомфортът след лечението обикновено е минимален и може да се овладее с обикновени болкоуспокояващи.",
      },
      {
        question: "Колко време отнема пародонталното лечение?",
        answer:
          "Продължителността зависи от тежестта на вашето състояние. Първоначалните лечения може да изискват 1-2 посещения, докато по-сложните случаи може да се нуждаят от няколко визити в продължение на седмици или месеци. Поддържащите прегледи обикновено се насрочват на всеки 3-4 месеца.",
      },
      {
        question: "Може ли заболяването на венците да бъде излекувано?",
        answer:
          "Ранното заболяване на венците (гингивит) може да бъде излекувано с професионално лечение и добра устна хигиена. Напредналото пародонтално заболяване не може да бъде напълно излекувано, но може да бъде ефективно контролирано, за да се предотврати прогресирането и да се спасят засегнатите зъби.",
      },
      {
        question: "Свързано ли е пародонталното заболяване с други здравословни състояния?",
        answer:
          "Да, изследванията показват връзки между пародонталното заболяване и няколко системни състояния, включително сърдечни заболявания, диабет, респираторни заболявания и определени усложнения по време на бременност. Поддържането на здрави венци допринася за цялостното ви здраве.",
      },
    ],
  },
};

export default periodontology;

